import { createContext } from "react";
import { IAdminProps } from "../../../types";

interface IAppContextProps {
  profile: IAdminProps | null;
  reloadProfile: () => void;
  isLoadingProfile: boolean;
}

export const AppContext = createContext<IAppContextProps>({
  profile: null,
  reloadProfile: () => {},
  isLoadingProfile: false,
});
